import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

type Props = IIconProps & { size?: number }

export const AlertIcon60: FunctionComponent<Props> = ({ size, ...props }) => {
  const originalWidth = 20.0

  const originalHeight = 17.0

  const maxDim = Math.max(originalWidth, originalHeight)

  const scale = size ? size / maxDim : 1

  const width = originalWidth * scale

  const height = originalHeight * scale

  return (
    <Icon viewBox="0 0 20 17" width={width} height={height} {...props}>
      <Path
        d="M7.9962 0C6.8954 0 5.9994 0.952002 5.9994 2.121L2.9344 2.125C1.3156 2.125 0 3.523 0 5.243V12.75C0 15.093 1.7934 17 4 17H15.9994C18.2066 17 20 15.093 20 12.75V5.243C20 3.523 18.6831 2.125 17.0643 2.125H13.9994V2.121C13.9994 0.952002 13.1039 0 12.0026 0H7.9962ZM0.999699 12.75V5.243C0.999699 4.109 1.8676 3.187 2.9344 3.187H6.4989C6.7758 3.187 6.9997 2.95001 6.9997 2.65601V2.121C6.9997 1.537 7.4468 1.062 7.9962 1.062H12.0026C12.5532 1.062 12.9997 1.537 12.9997 2.121V2.65601C12.9997 2.95001 13.2229 3.187 13.4998 3.187H17.0643C18.1311 3.187 18.9997 4.109 18.9997 5.243V12.75C18.9997 14.507 17.6533 15.937 15.9994 15.937H4C2.3454 15.937 0.999699 14.507 0.999699 12.75ZM14.5002 5.312C14.2226 5.312 13.9994 5.54899 13.9994 5.84399C13.9994 6.13799 14.2226 6.37399 14.5002 6.37399H16.4989C16.7758 6.37399 16.999 6.13799 16.999 5.84399C16.999 5.54899 16.7758 5.312 16.4989 5.312H14.5002ZM5.9994 9.562C5.9994 11.906 7.7934 13.812 9.9994 13.812C12.2053 13.812 13.9994 11.906 13.9994 9.562C13.9994 7.219 12.2053 5.312 9.9994 5.312C7.7934 5.312 5.9994 7.219 5.9994 9.562ZM6.9997 9.562C6.9997 7.805 8.346 6.37399 9.9994 6.37399C11.654 6.37399 12.9997 7.805 12.9997 9.562C12.9997 11.32 11.654 12.75 9.9994 12.75C8.346 12.75 6.9997 11.32 6.9997 9.562Z"
        fill="#404040"
      />
    </Icon>
  )
}
